// Selkirk Copper Design System - Color Palette
// Based on the company logo: Black, Gold, and complementary colors

export const colors = {
  // Primary Brand Colors (from Selkirk Copper logo)
  primary: {
    50: '#fffbeb',   // Very light gold
    100: '#fef3c7',  // Light gold
    200: '#fde68a',  // Pale gold
    300: '#fcd34d',  // Medium gold
    400: '#fbbf24',  // Standard gold
    500: '#f9be0b',  // Primary gold (exact from logo: #F9BE0B)
    600: '#d97706',  // Dark gold
    700: '#b45309',  // Darker gold
    800: '#92400e',  // Deep gold
    900: '#78350f',  // Darkest gold
  },

  // Secondary/Neutral Colors (black/gray scale)
  neutral: {
    50: '#f9fafb',   // Almost white
    100: '#f3f4f6',  // Very light gray
    200: '#e5e7eb',  // Light gray
    300: '#d1d5db',  // Medium light gray
    400: '#9ca3af',  // Medium gray
    500: '#6b7280',  // Standard gray
    600: '#4b5563',  // Dark gray
    700: '#374151',  // Darker gray
    800: '#1f2937',  // Very dark gray
    900: '#111827',  // Almost black
    950: '#030712',  // Pure black (from logo)
  },

  // Accent Colors
  accent: {
    blue: '#3b82f6',    // Professional blue
    green: '#10b981',   // Success green
    red: '#ef4444',     // Error red
    orange: '#f97316',  // Warning orange
    purple: '#8b5cf6',  // Info purple
  },

  // Semantic Colors
  success: {
    50: '#ecfdf5',
    500: '#10b981',
    600: '#059669',
    700: '#047857',
  },
  
  warning: {
    50: '#fffbeb',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
  },
  
  error: {
    50: '#fef2f2',
    500: '#ef4444',
    600: '#dc2626',
    700: '#b91c1c',
  },
  
  info: {
    50: '#eff6ff',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
  }
};

// Theme Variants
export const lightTheme = {
  background: {
    primary: colors.neutral[50],
    secondary: colors.neutral[100],
    tertiary: colors.neutral[200],
    elevated: '#ffffff',
  },
  text: {
    primary: colors.neutral[900],
    secondary: colors.neutral[700],
    tertiary: colors.neutral[500],
    inverse: colors.neutral[50],
  },
  border: {
    primary: colors.neutral[200],
    secondary: colors.neutral[300],
    accent: colors.primary[500],
  }
};

export const darkTheme = {
  background: {
    primary: colors.neutral[950],     // Pure black background
    secondary: colors.neutral[900],   // Card backgrounds
    tertiary: colors.neutral[800],    // Elevated surfaces
    elevated: colors.neutral[700],    // Modals, dropdowns
  },
  text: {
    primary: colors.neutral[50],      // Primary text (white)
    secondary: colors.neutral[300],   // Secondary text
    tertiary: colors.neutral[400],    // Muted text
    inverse: colors.neutral[900],     // Dark text on light backgrounds
  },
  border: {
    primary: colors.neutral[700],     // Subtle borders
    secondary: colors.neutral[600],   // More prominent borders
    accent: colors.primary[500],      // Gold accent borders
  }
};

// Default theme (dark)
export const theme = {
  colors,
  mode: 'dark',
  ...darkTheme,
  primary: colors.primary[500],       // Gold (#f9be0b - exact from logo)
  secondary: colors.neutral[600],     // Dark gray
  accent: colors.primary[400],        // Lighter gold for accents
};

export default theme;
